module.exports = __webpack_public_path__ + "static/img/18.4629cfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/18.jpg
// module id = Eqv+
// module chunks = 1